import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import { CcReviewReviewHistory } from "server/models"
import {
    StoreType,
    ReviewReviewHistoryValidation,

    UpdateCcReviewReviewHistoryResponse,
    LoadCcReviewReviewHistory,
    setCcReviewReviewItemHistory,
} from "client/store"
import { StateType } from "client/utils"
import {
    PageForm,
    FormGroup,
    Label,
    Delimiter,
    LinkButton,
    Button,
    ButtonGroup,
    ButtonGroupItem,
    Feedback,
    SpinnerIcon,

    PrepareNestedHistory,
    NestedHistory,
    HistoryList,

    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmBottom,
} from "client/components"

const History = () => {
    const history = useSelector((state: StoreType) => state.ccReviewReview.itemHistory)
    const responseList = useSelector((state: StoreType) => state.ccResponse.responseList)
    const moduleResponseList = useSelector((state: StoreType) => state.ccResponse.moduleResponseList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const responseIds = moduleResponseList[3]
    const responsibleResponseIds = moduleResponseList[0]

    const [hidePrev, setHidePrev] = useState(true)
    const [nestedHistory, setNestedHistory] = useState<NestedHistory[]>([])
    const [historyRow, setHistoryRow] = useState<CcReviewReviewHistory>(null)
    const [responseId, setResponseId] = useState<number>(null)

    const [validation, setValidation] = useState<ReviewReviewHistoryValidation>(null)
    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        const nested = PrepareNestedHistory(history)
        setNestedHistory(nested)
    }, [history])

    const showHideHistory = () => {
        setHidePrev(!hidePrev)
    }

    const onEditAnswer = (row: CcReviewReviewHistory) => {
        // only rows with response selected are allowed to edit
        setHistoryRow(row)
        setResponseId(row.responseId)
    }

    const stopEditAnswer = () => {
        setHistoryRow(null)
        setResponseId(null)
    }

    const onSaveAnswer = () => {
        setSaveState(PENDING)
        UpdateCcReviewReviewHistoryResponse(historyRow.id, responseId, lang)
        .then((resValidation) => {
            setValidation(resValidation)
            if (resValidation) {
                setSaveState(IDLE)
                return
            }

            LoadCcReviewReviewHistory(historyRow.itemId, historyRow.reviewReviewRevisionId).then((resHistory) => {
                dispatch(setCcReviewReviewItemHistory(resHistory))

                setSaveState(IDLE)
                stopEditAnswer()
            })
        })
    }

    const targetResponseIds = historyRow && historyRow.parentId === null ? responsibleResponseIds : responseIds

    return (
        <PageForm noPaddingTop>
            <Row>
                <Col xs={12}>
                    <Delimiter />
                    <FormGroup>
                        <Label>{lang.history}</Label>
                    </FormGroup>

                    {
                        nestedHistory.length > 1 && (
                            <p>
                                <LinkButton onClick={showHideHistory}>
                                    {hidePrev ? lang.showPrevious : lang.hidePrevious}
                                </LinkButton>
                            </p>
                        )
                    }

                    <HistoryList
                        nested={hidePrev && nestedHistory.length > 1
                            ? [nestedHistory[nestedHistory.length - 1]]
                            : nestedHistory}
                        onEditAnswer={onEditAnswer}
                    />
                </Col>
            </Row>

            <ConfirmWrapper
                show={historyRow !== null}
                onClose={stopEditAnswer}
            >
                <Confirm>
                    <ConfirmTitle>{lang.updateResponse}</ConfirmTitle>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.response}</Label>
                                <ButtonGroup>
                                    {
                                        targetResponseIds && targetResponseIds.map((id) => (
                                            <ButtonGroupItem
                                                key={id}
                                                active={responseId === id}
                                                onClick={() => setResponseId(id)}
                                            >
                                                {responseList[id] ? responseList[id].response : ""}
                                            </ButtonGroupItem>
                                        ))
                                    }
                                </ButtonGroup>
                                <Feedback>{validation && validation.responseId}</Feedback>
                            </FormGroup>
                        </Col>
                    </Row>

                    <ConfirmBottom>
                        <Button row onClick={stopEditAnswer}>{lang.cancel}</Button>
                        <Button variant="success" row onClick={onSaveAnswer}>
                            {saveState === PENDING ? <SpinnerIcon /> : lang.confirm}
                        </Button>
                    </ConfirmBottom>
                </Confirm>
            </ConfirmWrapper>
        </PageForm>

    )
}
export default History
